<h2 mat-dialog-title>Update required</h2>

<div class="p-x-24 p-b-24">
  {{ data.message }}
</div>

<div mat-dialog-actions class="p-24 p-t-0">
  <button mat-flat-button (click)="update()" color="primary">
    @if (isNative) {
      Update
    } @else {
      Reload
    }
  </button>
</div>
